export const CLASS_NAMES = {
	delayed: "delayed",
	disabled: "disabled",
	hidden: "hidden",
    FLIGHT_CHANGE_SEARCH_OUTBOUND_DATE_CLASS: "flight-change-search-outbound-date",
	FLIGHT_CHANGE_SEARCH_RETURN_DATE_CLASS: "flight-change-search-return-date",
	FLIGHT_CHANGE_SEARCH_PASSENGER_SELECTOR_CLASS: "flight-change-search-passenger-selector",
	invalid: "invalid",
};
